module.exports = __webpack_public_path__ + "files/3e17e81207de4c75a29a0372ce2f600e.png";